import { render, staticRenderFns } from "./RegistroForm.vue?vue&type=template&id=3bebaad9&scoped=true&"
import script from "./RegistroForm.vue?vue&type=script&lang=js&"
export * from "./RegistroForm.vue?vue&type=script&lang=js&"
import style0 from "./RegistroForm.vue?vue&type=style&index=0&id=3bebaad9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bebaad9",
  null
  
)

export default component.exports